export const types = {
	addForm: 'add_form',
	getForm: 'get_form',
}


export function addAction(data: any) {
	return {
		type: types.addForm,
		data
	}
}

/*
 *  @params shop_domain    域名前缀
 *  @params shop_name  	   店铺名称
 *  @params presentation   店铺简介
 *  @params supplier_data  原材料供应商
 *  @params customer_data  优选客户
 *  @params shop_domain  域名前缀
 *  @params shop_domain  域名前缀
*/

export interface initFace {
	isInit: boolean,
	shop_domain : string,
	shop_name: string,
	presentation: string,
	supplier: Array<any>,
	customers: Array<any>,
	pc_logo: string,
	mobile_logo: string,
}

const initState = {
	isInit: false,
	shop_domain: '',
	shop_name: '',
	presentation: '',
	supplier: [],
	customers: [],
	pc_logo: '',
	mobile_logo: '',
}

export default function infoForm(state:initFace = initState, action: any) {
	// console.log(state, 'state')

	switch (action.type) {
        case 'add_form':
            return {
            	...state,
            	...action.data
            }
        default:
         return state   
    }
}